
import lodash_range from "lodash/range";

export default {
  name  : "Paging",
  props : ["paging", "callback"],
  methods: {
    range: function(start, end) {
      // IE 지원때문에 es6 문법은 사용하지 않는다.
      // return Array(end - start + 1).fill().map((_, idx) => start + idx)
      return lodash_range(start, end + 1);
    }
  }
};
